import React, { useEffect, useRef, useState, useCallback } from "react";
import { ListBox } from "primereact/listbox";
import { SelectButton } from "primereact/selectbutton";
import { InputMask } from "primereact/inputmask";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tree } from "primereact/tree";
import kpiService from "@services/kpi.service";
import performanceManagementService from "@services/performanceManagement.service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ColorPicker } from "primereact/colorpicker";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import CodeMirror from "@uiw/react-codemirror";
import { EditorState } from "@codemirror/state";
import { autocompletion } from "@codemirror/autocomplete";
import { EditorView } from "@codemirror/view"
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { Toast } from 'primereact/toast';
import { MathComponent } from "mathjax-react";
import { Panel } from 'primereact/panel';
import { FileUpload } from 'primereact/fileupload';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
export default function Clusters() {
  const [nodes, setNodes] = useState([]);
  const [data, setData] = useState([]);
  const [update, setUpdate] = useState(false);
  const toast = useRef(null);
  const [visible, setVisible] = useState(false);
  const [selectedTech, setSelectedTech] = useState(null);
  const techs = ['LTE', 'UMTS'];
  const [cName, SetCName] = useState('');
  const [attach, setAttach] = useState([]);
  const [blocked, setBlocked] = useState(false);
  const fileUploader = useRef(null);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    CellName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Site: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Sector: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Province: { value: null, matchMode: FilterMatchMode.CONTAINS },
    City: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Carrier: { value: null, matchMode: FilterMatchMode.CONTAINS },
    RNC: { value: null, matchMode: FilterMatchMode.CONTAINS },
    TAC: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Bandwith: { value: null, matchMode: FilterMatchMode.CONTAINS },

  });
  useEffect(() => {
    performanceManagementService
      .Post("/rightel/cluster/list")
      .then((response) => {
        setNodes(response.data);
      })
      .catch((err) => { });
  }, [update]);

  const onSelect = (event) => {
    let name = event.node.key.split("-")[1];
    let tech = event.node.key.split("-")[0];
    performanceManagementService
      .Post("/rightel/cluster/cells/", { name: name, tech: tech })
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => { });
  };

  const save = () => {
    const formData = new FormData();
    formData.append("file", attach);
    formData.append("name", cName);
    formData.append("tech", selectedTech);
    setBlocked(true);
    performanceManagementService
      .PostForm("/rightel/cluster/upsert", formData)
      .then((response) => {
        setUpdate(!update);
        setVisible(false);
      })
      .catch((err) => { })
      .finally(() => {
        setBlocked(false);
      })
      ;
  };

  const confirm2 = (key) => {

    confirmDialog({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      accept: () => deleteItem(key),
      reject: null
    });
  };

  const deleteItem = (key) => {

    let name = key.split("-")[1];
    let tech = key.split("-")[0];
    performanceManagementService
      .Post("/rightel/cluster/delete", { name: name, tech: tech })
      .then((response) => {
        setUpdate(!update);
        setData([]);
      })
      .catch((err) => { })
      .finally(() => {
        setBlocked(false);
      })
      ;
  };
  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    return (
      <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
        {chooseButton}
        {cancelButton}

      </div>
    );
  };

  const nodeTemplate = (node, options) => {
    let label = node.label;
    if (!node.children) {
      return (<>
        <Button rounded text severity="danger" onClick={() => confirm2(node.key)} icon="pi pi-times-circle" className="mr-2" />
        <span className={options.className}>{label}</span>
      </>
      )
    }
    return (
      <>
        <span className={options.className}>{label}</span>
        <Button rounded text severity="help" onClick={() => { setVisible(true); setSelectedTech(node.label) }} icon="pi pi-plus" className="mr-2" />
      </>
    );
  }
  return (
    <>
      {/* <div className="grid grid-cols-12 ">
        <div className="col-span-12">
          <Toolbar className="m-2" start={startContent} end={endContent} />
        </div>

      </div> */}
      <div className="grid grid-cols-12 grid-rows-1 gap-2">
        <div className="col-span-3">
          <div className="card flex justify-content-center">
            <Tree
              onSelect={onSelect}
              filter
              selectionMode="single"
              style={{ maxHeight: "680px", overflow: "auto" }}
              value={nodes}
              nodeTemplate={nodeTemplate}
              className="w-full md:w-30rem"
            />
          </div>
        </div>
        <div className="col-span-9">
          <div>
            <div className="card">
              <DataTable value={data} paginator rows={50} filters={filters} filterDisplay="row" tableStyle={{ minWidth: '50rem' }}>
                {data[0] && Object.keys(data[0]).map((col, i) => (
                  <Column key={col} filter filterPlaceholder="Search by name" field={col} header={col} />
                ))}
              </DataTable>
            </div>
          </div>
        </div>
      </div>
      <Dialog header="Header" visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        Tech :
        <div className="card flex  justify-content-center">
          <Dropdown value={selectedTech} onChange={(e) => setSelectedTech(e.value)} options={techs}
            placeholder="Select a Tech" className=" md:w-14rem" />

        </div>
        Name :
        <div className="card flex justify-content-center mt-2">
          <InputText value={cName} onChange={(e) => SetCName(e.target.value)} />
        </div>

        File:
        <div className="card flex justify-content-center mt-2">
          <FileUpload headerTemplate={headerTemplate} multiple={false} ref={fileUploader} accept={"CSV/*"} name="attachments" onClear={(e) => setAttach([])} onSelect={(e) => setAttach(e.files[0])} maxFileSize={5000000} emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} />
        </div>

        <div className="card flex justify-content-center  mt-4">
          <Button label="Save" onClick={save} />
        </div>
      </Dialog >
      <ConfirmDialog />

    </>

  );
}
